import type { AxiosInstance } from 'axios';
import type {
  PlotMarker,
  PlotMarkerListResponse,
  ListQueryParams,
  PlotMarkerCreateRequest,
  PlotMarkerUpdateRequest,
  EntityId,
} from '@/types';

export const getPlotMarkers = async (
  api: AxiosInstance,
  plot_id: EntityId,
  waypoint_id: EntityId,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<PlotMarkerListResponse> => {
  const resp = await api.get<PlotMarkerListResponse>(
    `/plot/${plot_id}/waypoint/${waypoint_id}/marker`,
    {
      params: { limit, start_key, name } as ListQueryParams,
    },
  );
  return resp.data;
};

export const getPlotMarker = async (
  api: AxiosInstance,
  plot_id: EntityId,
  waypoint_id: EntityId,
  marker_id: EntityId,
): Promise<PlotMarker> => {
  const resp = await api.get<PlotMarker>(
    `/plot/${plot_id}/waypoint/${waypoint_id}/marker/${marker_id}`,
  );
  return resp.data;
};

export const createPlotMarker = async (
  api: AxiosInstance,
  plot_id: EntityId,
  waypoint_id: EntityId,
  values: PlotMarkerCreateRequest,
): Promise<PlotMarker> => {
  const resp = await api.post<PlotMarker>(
    `/plot/${plot_id}/waypoint/${waypoint_id}/marker`,
    values,
  );
  return resp.data;
};

export const updatePlotMarker = async (
  api: AxiosInstance,
  plot_id: EntityId,
  waypoint_id: EntityId,
  marker_id: EntityId,
  values: PlotMarkerUpdateRequest,
): Promise<PlotMarker> => {
  const resp = await api.put<PlotMarker>(
    `/plot/${plot_id}/waypoint/${waypoint_id}/marker/${marker_id}`,
    values,
  );
  return resp.data;
};

export const deletePlotMarker = async (
  api: AxiosInstance,
  plot_id: EntityId,
  waypoint_id: EntityId,
  marker_id: EntityId,
): Promise<void> => {
  const resp = await api.delete(
    `/plot/${plot_id}/waypoint/${waypoint_id}/marker/${marker_id}`,
  );
  return resp.data;
};

